import { faCheck, faQuestion, faXmark, } from '@awesome.me/kit-cf858715fd/icons/classic/solid';
export function getInviteeRsvpStatusDisplay(responseStatus, token) {
    switch (responseStatus) {
        case 'accepted':
            return {
                icon: faCheck,
                show: true,
                color: token.colorSuccess,
                statusBgColor: token.colorSuccessBg,
            };
        case 'declined':
            return {
                icon: faXmark,
                show: true,
                color: token.colorError,
                statusBgColor: token.colorErrorBg,
            };
        case 'tentative':
            return {
                icon: faQuestion,
                show: true,
                color: token.colorWarning,
                statusBgColor: token.colorWarningBg,
            };
        case 'unknown':
        case 'not_responded':
        case 'delegated':
        default:
            return {
                icon: null,
                show: false,
                color: token.colorSuccess,
                statusBgColor: token.colorSuccessBg,
            };
    }
}
